import React, { ReactNode } from "react";

/**
 * @author sukim91
 * @date 2022-09-05 10:45:22
 * @remark 공통 Desc FlatList 구현
 * @param props DescListViewProps
 * @props DescListViewProps
 *       data: 렌더링할 데이터(리스트)
 *       renderItem: 렌더링할 Elements 함수
 * @returns renderItem
 */
export interface ListViewProps {
	data: any;
	renderItem: (...args: any) => ReactNode;
}

export function ListView(props: ListViewProps) {
	const listView = props.data.map((item: any, index: number) => {
		return props.renderItem(item, index);
	});

	return <>{React.Children.toArray(listView)}</>;
}

export default ListView;
